import ChartStyles from '@/utils/chart_styles'
import DoughnutLabelPlugin from '@/utils/doughnut_label_plugin'
import { Controller } from '@hotwired/stimulus'
import Chart from 'chart.js/auto'
import 'chartjs-adapter-luxon'

// Register the doughnut label plugin
Chart.register(DoughnutLabelPlugin)

export default class extends Controller {
  static targets = ['chart', 'chartLegend']
  static values = {
    weekClient: Number,
    weekInternal: Number,
    weekTotal: Number,
    monthTotal: Number
  }

  connect() {
    this.buildChart()
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
    }
  }

  buildChart() {
    const ctx = this.chartTarget
    const clientHours = this.weekClientValue
    const internalHours = this.weekInternalValue
    const totalHours = this.weekTotalValue

    if (totalHours === 0) {
      this.showEmptyChart()
      return
    }

    const chartData = {
      labels: ['Client Hours', 'Internal Hours'],
      datasets: [
        {
          data: [clientHours, internalHours],
          backgroundColor: [
            ChartStyles.colors.blue || '#0d6efd',
            ChartStyles.colors.yellow || '#ffc107'
          ],
          borderColor: [
            ChartStyles.colors.blue || '#0d6efd',
            ChartStyles.colors.yellow || '#ffc107'
          ],
          borderWidth: 1,
          hoverOffset: 4
        }
      ]
    }

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        crosshair: false,
        legend: {
          display: false
        },
        tooltip: {
          enabled: true,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          titleColor: '#ffffff',
          bodyColor: '#ffffff',
          borderColor: '#ffffff',
          borderWidth: 1,
          cornerRadius: 6,
          displayColors: true,
          callbacks: {
            label: (context) => {
              const value = context.raw
              const percentage = ((value / totalHours) * 100).toFixed(1)
              return `${context.label}: ${value}h (${percentage}%)`
            }
          }
        },
        doughnutlabel: {
          labels: [
            {
              text: `${this.formatHours(totalHours)}`,
              font: {
                size: 14,
                weight: 'bold'
              }
            },
            {
              text: 'Total',
              font: {
                size: 10
              },
              color: '#6c757d'
            }
          ]
        }
      },
      cutout: '60%',
      elements: {
        arc: {
          borderRadius: 2
        }
      }
    }

    this.chart = new Chart(ctx, {
      type: 'doughnut',
      data: chartData,
      options: options,
      plugins: [DoughnutLabelPlugin]
    })
  }

  showEmptyChart() {
    this.chartTarget.parentElement.innerHTML = `
      <div class="text-center text-muted py-3">
        <div class="small">No hours logged this week</div>
      </div>
    `
  }

  formatHours(hours) {
    const numHours = parseFloat(hours)
    return numHours % 1 === 0 ? numHours.toString() : numHours.toFixed(2)
  }
}
